import type { ReactNode } from "react";

type Tone = "neutral" | "ok" | "warn" | "err";

interface BadgeProps {
  tone?: Tone;
  children: ReactNode;
}

const toneClass: Record<Tone, string> = {
  neutral: "",
  ok: "badge--ok",
  warn: "badge--warn",
  err: "badge--err",
};

export function Badge({ tone = "neutral", children }: BadgeProps) {
  return <span className={`badge ${toneClass[tone]}`.trim()}>{children}</span>;
}
